// extracted by mini-css-extract-plugin
module.exports = {"container":"header-module--container--18lpt","text":"header-module--text--L87g5","logo":"header-module--logo--3gu8x"};